module.exports = __webpack_public_path__ + "img/img_19.6b8ba9b1.jpg";